import { Link } from "react-router-dom";
import { movies, newsList, specials } from "@/lib/content";

const stats = [
  { value: String(movies.length), label: "精选剧集", suffix: "部" },
  { value: String(newsList.length), label: "深度资讯", suffix: "篇" },
  { value: String(specials.length), label: "主题专题", suffix: "个" },
  { value: "3", label: "每周更新", suffix: "次" },
];

export default function AboutBand() {
  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <div className="w-full">
          <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20editorial%20screening%20room%20with%20vintage%20cinema%20seats%20and%20a%20glowing%20projection%20screen%2C%20soft%20navy%20shadows%20and%20amber%20lamp%20light%2C%20calm%20film%20magazine%20workspace%20atmosphere%2C%20no%20text&width=1200&height=900&seq=about-editorial-room&orientation=landscape"
              alt="奸情影视内容站编辑部观片室，暖光与深色放映空间"
              title="奸情影视内容站 - 编辑部观片室"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute bottom-4 left-4 rounded-md bg-primary-950/70 px-3 py-2 backdrop-blur-sm">
              <p className="font-label text-[10px] uppercase tracking-[0.24em] text-background-300">Editorial Room</p>
              <p className="mt-1 font-heading text-sm font-bold text-background-50">每一次推荐，都先看完再写</p>
            </div>
          </div>
        </div>

        <div>
          <p className="flex items-center gap-2 font-label text-xs font-bold uppercase tracking-[0.24em] text-accent-700">
            <span className="h-px w-6 bg-accent-500" />
            About Us
          </p>
          <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            关于奸情影视内容站
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px]">
            「奸情」专注影视剧推荐与剧情解析。我们不做简单的资源搬运，而是把每一部剧的叙事结构、
            人物动机与镜头细节拆开来讲，让观众在追剧之外，还能获得一次完整的阅读体验。
          </p>
          <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-[15px]">
            站内内容分为剧集推荐、剧情解析、资讯栏目与专题策划四条线，覆盖类型、地区与年份的多维筛选，
            并提供关键词检索，方便你按自己的兴趣找到下一部要看的剧。
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 p-4">
                <p className="font-label text-2xl font-black text-primary-800">
                  {stat.value}
                  <span className="ml-0.5 text-xs font-semibold text-foreground-400">{stat.suffix}</span>
                </p>
                <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/special"
              className="inline-flex items-center gap-2 rounded-md bg-primary-900 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors whitespace-nowrap hover:bg-primary-800"
            >
              看专题片单
              <i className="ri-arrow-right-line text-base" aria-hidden="true" />
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors whitespace-nowrap hover:border-primary-300 hover:text-primary-700"
            >
              搜索想看的内容
              <i className="ri-search-line text-base" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}